import React, { useEffect, useState } from "react";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";
import moment from "moment";

export const SearchInputType = ({ filterTitle, setSearchInputData, searchInputData }) => {
  const [selected, setSelected] = useState("");

  useEffect(() => {
    if (searchInputData === null || !searchInputData) {
      setSearchInputData("");
    } else {
      setSearchInputData(searchInputData);
    }
  }, [searchInputData]);

  const onSearchInputChange = (event) => {
    setSearchInputData(event.target.value);
  };

  return (
    <div className="filter-main">
      <div class="filter-label">{filterTitle}</div>
      <input
        type={"text"}
        placeholder="Search by question..."
        value={searchInputData}
        onChange={onSearchInputChange}></input>
    </div>
  );
};

export const QuestionType = ({
  filterTitle,
  questionTypes,
  questionTypesData,
  setAnswerTypeId,
  answerTypeId,
  setLimit,
}) => {
  const value = questionTypes;
  const [selected, setSelected] = useState("All");

  useEffect(() => {
    if (answerTypeId === null || !answerTypeId) {
      setSelected("All");
    } else {
      questionTypesData.map((questionTypesOption) => {
        if (answerTypeId == questionTypesOption.AnswerTypeId) {
          setSelected(questionTypesOption.AnswerType);
        }
      });
    }
  }, [answerTypeId]);

  const onFilterChange = (event) => {
    setLimit(1);
    var selectedIndex = value.indexOf(event);
    if (selectedIndex < 0) {
      setAnswerTypeId("");
    } else {
      setAnswerTypeId(questionTypesData[selectedIndex]["AnswerTypeId"]);
    }
  };

  return (
    <div className="filter-main">
      <div className="filter-label">{filterTitle}</div>
      <DropdownButton alignRight title={selected} id="dropdown-menu-align-right" onSelect={onFilterChange}>
        <Dropdown.Item eventKey="All" className={selected === "All" ? "active" : ""}>
          All
        </Dropdown.Item>
        {value.map((option, index) => (
          <Dropdown.Item key={index} eventKey={option} className={selected === option ? "active" : ""}>
            {option}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );
};

export const DateRange = ({ setStartDate, setEndDate, startDate, endDate }) => {
  const startDateInputSettings = {
    spinners: false,
    label: "Start Date",
    format: "MM/dd/yyyy",
    formatPlaceholder: "formatPattern",
  };
  const endDateInputSettings = {
    spinners: false,
    label: "End Date",
    format: "MM/dd/yyyy",
    formatPlaceholder: "formatPattern",
  };

  const onDateChange = (event) => {
    if (event.value.start && event.value.end) {
      setStartDate(moment(event.value.start).format("YYYY-MM-DD"));
      setEndDate(moment(event.value.end).format("YYYY-MM-DD"));
    }
  };

  return (
    <div className="date-range-main">
      <DateRangePicker
        id="DateRangePicker"
        startDateInputSettings={startDateInputSettings}
        endDateInputSettings={endDateInputSettings}
        onChange={onDateChange}
      />
    </div>
  );
};

export const OrderBy = ({ filterTitle, setSortBy, sortBy }) => {
  const orders = ["# of responses - Ascending", "# of responses - Descending"];

  {
    /*} Questions ascending , Questions descending  "# of responses ascending",
  "# of responses descending", {*/
  }

  const [selected, setSelected] = useState("-");

  useEffect(() => {
    if (sortBy === null || !sortBy) {
      setSelected("-");
    }
  }, [sortBy]);

  const onFilterChange = (event) => {
    setSelected(event);
    setSortBy(orders.indexOf(event) + 1);
  };
  return (
    <div className="filter-main">
      <div className="filter-label">{filterTitle}</div>
      <DropdownButton
        alignRight
        title={selected === "-" ? "Question No." : selected}
        id="dropdown-menu-align-right"
        onSelect={onFilterChange}>
        <Dropdown.Item eventKey="-" className={selected === "-" ? "active" : ""}>
          {"Question No."}
        </Dropdown.Item>
        {orders.map((option, index) => (
          <Dropdown.Item key={index} eventKey={option} className={selected === option ? "active" : ""}>
            {option}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );
};
